import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from "./locales/en/en.json"
import pt from "./locales/pt/pt.json"
import es from "./locales/es/es.json"
import fr from "./locales/fr/fr.json"
import it from "./locales/it/it.json"
import de from "./locales/de/de.json"
import jp from "./locales/jp/jp.json"

export default i18next.use(initReactI18next).init({
    resources: {
        pt: {
            translation: pt,
        },
        en: {
            translation: en,
        },
        es: {
            translation: es,
        },
        fr: {
            translation: fr,
        },
        it: {
            translation: it,
        },
        de: {
            translation: de,
        },
        jp: {
            translation: jp,
        }
    },
    lng: localStorage.getItem("lng") || "en",
})